export const COMMUNITIES_PER_PAGE = 20

export const REQUEST_CONFIG = {
  cacheTime: 1000 * 60 * 60 * 24, // 24 hours
  staleTime: 1000 * 60 * 60 * 24 // 24 hours
}
